import React from "react";
import { StateContext } from "../../UserContext";
import { AuthStateType } from "../../UserReducer";

export function useAuthState() : AuthStateType {
	const context = React.useContext(StateContext);
	if (context === undefined) {
		throw new Error('useAuthState must be used within a AuthProvider');
	}

	return context;
}